export enum ThemeColorPalette {
    MATURE_GOLD = "#c8b33b",
    // MATURE_GOLD = "#c8b33b",
}